import { render, staticRenderFns } from "./supply-chain.vue?vue&type=template&id=d7543cc2&scoped=true&"
import script from "./supply-chain.vue?vue&type=script&lang=js&"
export * from "./supply-chain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7543cc2",
  null
  
)

export default component.exports